import React from 'react';
import { generateBadgeTheme } from '../../utils/badgeUtils';
import './DynamicBadge.css';

/**
 * A premium, reusable badge component that generates colors dynamically based on text.
 */
const DynamicBadge = ({ text, onClick, className = "" }) => {
  const theme = generateBadgeTheme(text);

  const style = {
    backgroundColor: theme.bg,
    color: theme.text,
    border: `1px solid ${theme.border}`,
  };

  return (
    <span
      className={`premium-dynamic-badge ${onClick ? 'clickable' : ''} ${className}`}
      style={style}
      onClick={onClick}
      title={text}
    >
      {text}
    </span>
  );
};

export default DynamicBadge;
